export const CHANGE_VOUCHERS = 'CHANGE_VOUCHERS';
export const CHANGE_VOUCHERS_VISIBILITY = 'CHANGE_VOUCHERS_VISIBILITY';
export const CHANGE_VOUCHER_SELECTED = 'CHANGE_VOUCHER_SELECTED';
export const LOAD_VOUCHERS = 'LOAD_VOUCHERS';

export const UPDATE_VOUCHER_SUCCESS = 'UPDATE_VOUCHER_SUCCESS';
export const UPDATE_VOUCHER_ERROR = 'UPDATE_VOUCHER_ERROR';
export const UPDATE_VOUCHER_CLEAR_RESULT = 'UPDATE_VOUCHER_CLEAR_RESULT';
